"use client";

import React from "react";
import MenuItem from "./MenuItem";
import { MenuNode } from "./menuAdapter";

interface MenuColumnProps {
  title: string;
  items: MenuNode[];
  activeSlug?: string;
  hoveredSlug?: string;
  widthClass?: string;
  onItemHover: (node: MenuNode) => void;
  onItemClick: () => void;
}

export default function MenuColumn({
  title,
  items,
  activeSlug,
  hoveredSlug,
  widthClass = "w-[240px]",
  onItemHover,
  onItemClick,
}: MenuColumnProps) {
  return (
    <div className={`${widthClass} flex-shrink-0 flex flex-col px-7 py-5 h-auto`}>
      {/* Column Title */}
      <h3 className="text-[11px] font-bold text-slate-500 tracking-wide uppercase mb-[18px] px-2">
        {title}
      </h3>
      
      {/* Scrollable List Container */}
      <div className="flex-grow overflow-y-auto max-h-none pr-1.5 space-y-1 scrollbar-thin scrollbar-thumb-slate-200/80 scrollbar-track-transparent custom-thin-scrollbar">
        {items.map((node) => (
          <MenuItem
            key={node.id}
            node={node}
            isActive={activeSlug === node.id}
            isHovered={hoveredSlug === node.id}
            onHover={() => onItemHover(node)}
            onClick={onItemClick}
          />
        ))}
      </div>
    </div>
  );
}
